import * as React from "react";
import { singleton } from "logic/singleton";
export const initialState = {
  result: void 0,
  finishedLoading: false,
  setContextValue: () => {
  }
};
const OktaMatchingGroupsContext = React.createContext(initialState);
export default singleton("contexts.authentication.enterprise.okta.groupSync", () => OktaMatchingGroupsContext);
